import { env } from '@/lib/env';

export function formsEdgeHeaders(
  accessToken: string,
  options?: { jsonBody?: boolean },
): HeadersInit {
  const headers: Record<string, string> = {
    Authorization: `Bearer ${accessToken}`,
    apikey: env.VITE_SUPABASE_ANON_KEY,
    'x-application-name': 'clinio-web',
  };
  // GET + Content-Type: application/json and no body is a gateway 400 on
  // hosted functions (Safari then reports CORS). Only set it when we POST JSON.
  if (options?.jsonBody) {
    headers['Content-Type'] = 'application/json';
  }
  return headers;
}

export function formsEdgeUrl(functionName: string, query?: Record<string, string>): string {
  const url = new URL(`${env.VITE_SUPABASE_URL}/functions/v1/${functionName}`);
  if (query) {
    for (const [key, value] of Object.entries(query)) {
      url.searchParams.set(key, value);
    }
  }
  return url.toString();
}

export function formsEdgeErrorMessage(
  status: number,
  json: { error?: { message?: string } },
  fallback: string,
): string {
  if (json.error?.message) return json.error.message;
  if (status === 401) return 'You need to sign in again before continuing.';
  if (status === 403) return 'You do not have permission to do this.';
  if (status === 409) return 'A previous attempt is still finishing. Wait a minute and try again.';
  return `${fallback} (${status})`;
}
